// components/common/UserSelect.tsx
import React, { useState } from 'react';
import { Select, Spin } from 'antd';
import { debounce } from 'lodash';
import type { NubUserDTO } from '@/shared/api/model';
import {useUserSearch} from "@/hooks/admin/users";

interface UserSelectProps {
    value?: string;
    onChange?: (value: string, option: any) => void;
    placeholder?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
}

export const UserSelect: React.FC<UserSelectProps> = ({
                                                          value,
                                                          onChange,
                                                          placeholder = 'Search users',
                                                          style,
                                                          disabled = false
                                                      }) => {
    const [options, setOptions] = useState<{label: string, value: string}[]>([]);
    const { mutateAsync: searchUsers, isPending } = useUserSearch();

    const handleSearch = debounce(async (searchTerm: string) => {
        if (searchTerm.length < 2) {
            setOptions([]);
            return;
        }

        try {
            const users = await searchUsers(searchTerm);
            const newOptions = users.map((user: NubUserDTO) => ({
                label: `${user.fullName} (${user.userId})`,
                value: user.userId || ''
            }));
            setOptions(newOptions);
        } catch (error) {
            console.error('Error searching users:', error);
            setOptions([]);
        }
    }, 300);

    return (
        <Select
            showSearch
            value={value}
            placeholder={placeholder}
            style={style}
            defaultActiveFirstOption={false}
            suffixIcon={null}
            filterOption={false}
            onSearch={handleSearch}
            onChange={onChange}
            notFoundContent={isPending ? <Spin size="small" /> : null}
            options={options}
            disabled={disabled}
            allowClear={true}
        />
    );
};